var map = {
	"./rosario_en.json": 161,
	"./rosario_es.json": 162,
	"./rosario_por.json": 163,
	"./uplanner_en.json": 164,
	"./uplanner_es.json": 165,
	"./uplanner_por.json": 166
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;



//////////////////
// WEBPACK FOOTER
// ./src/lang ^\.\/.*\.json$
// module id = 160
// module chunks = 0